import React, { useCallback, useEffect, useState } from "react";

import Table from "../../components/table/Table";
import { api } from "../../api/api";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import moment from "moment/moment";

import Loader from "../../components/Loader/Loader";
import { Link, useNavigate } from "react-router-dom";
import { debounce } from "lodash";

import StudentCard from "../../components/StudentCard/StudentCard";

const Transactions = () => {
  const [data, setData] = useState([]);
  const { currUserData } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(1);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();

  const handleDelete = (rowIndex) => {
    const newData = [...data];
    newData.splice(rowIndex, 1);
    setData(newData);
  };

  const handleEdit = (rowIndex) => {
    const newData = [...data];
    const updatedValue = prompt(
      "Enter new value:",
      newData[rowIndex].CenterName
    );
    if (updatedValue) {
      newData[rowIndex].CenterName = updatedValue;
      setData(newData);
    }
  };

  const handelSearch = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((term) => {
      // Call your search API here
      getTransationData(term);
      console.log("Searching for:", term);
    }, 500), // Adjust debounce time (in milliseconds)
    []
  );

  const handleToggleStatus = (rowIndex) => {
    const newData = [...data];
    newData[rowIndex].status = !newData[rowIndex].status;
    setData(newData);
  };

  const getTransationData = async (term = "") => {
    setIsLoading(true);
    let res = await api(
      `api/v1/payment/getAllPaymentLogs?page=${
        pageIndex + 1
      }&limit=${pageSize}&search=${term}`,
      "",
      "get",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      console.log(res, "res res");
      setData(res?.data);
      setIsLoading(false);
      setTotalCount(res?.totalPayments);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "userId.name",
      },
      {
        Header: "Course ID",
        accessor: "courseId.courseId",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        Header: "Status",
        accessor: "paymentStatus",
      },

      {
        Header: "Payment Date",
        accessor: "paymentDate",
        Cell: ({ row }) =>
          moment(row.original.paymentDate, "YYYY-MM-DD").format("DD-MM-YYYY"),
      },

      // {
      //   Header: "Action",
      //   accessor: "",
      //   Cell: ({ row }) => (
      //     <span
      //       className=""
      //       // onClick={() => {
      //       //   navigate(`/ownerUsers/${row.original._id}`);
      //       // }}
      //     >
      //       <i class="fas fa-ellipsis-h"></i>
      //     </span>
      //   ),
      // },
    ],
    []
  );

  useEffect(() => {
    getTransationData();
  }, [pageIndex, pageSize]);

  return (
    <>
      <div className="appointment_list p-40">
        <div className="page_heading mb-5">
          <div>
            <p className="heading">Transactions List</p>
          </div>
        </div>

        <div className="appointment_list_box mt-5">
          <div className="row">
            <div className="col-md-12">
              {/* <div className="box_wrapper mb-4">
                <div className="table-content">
                  <div className="row page-header">
                    <div className="col">
                      <div className="d-flex justify-content-between p-20">
                        <h5 style={{ color: "#362F29" }} className="page-title">
                           New({dataSource.length}) 
                        </h5>
                        <div className="d-flex">
                          <SearchBar />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              <Table
                columns={columns}
                data={data}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onToggleStatus={handleToggleStatus}
                onSearch={handelSearch}
                isLoading={isLoading}
                totalCount={totalCount}
                pageIndex={pageIndex}
                pageSize={pageSize}
                setPageIndex={setPageIndex}
                setPageSize={setPageSize}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Transactions;
